import {
  uploadFileToBucket,
  useUploadToursFileDirectUploadMutation,
} from '@carboncopyco/data';
import type { MediaContent } from '@carboncopyco/types';
import { notify } from '@carboncopyco/ui';
import { base64toFile } from '@carboncopyco/utils';
import { v4 as generateUuid } from 'uuid';
import { useTourDispatch } from '../../hooks';
import { setIsMediaUploading } from '../../store';
import { useTourEditorPageProps } from './TourEditorPageContext';

interface Props {
  fileServiceApiToken: string;
  organizationId: string;
  onUploadProgress: (
    uploadProgress: number,
    fileServiceUrl: string,
    type: MediaContent['type']
  ) => void;
}

const useTooltipMedia = ({
  fileServiceApiToken,
  organizationId,
  onUploadProgress,
}: Props) => {
  const { uuid } = useTourEditorPageProps();
  const dispatch = useTourDispatch();

  const [uploadToursFileDirectUpload] =
    useUploadToursFileDirectUploadMutation();

  const uploadTooltipMedia = (media: string, type: MediaContent['type']) => {
    const resourceId = generateUuid();

    dispatch(
      setIsMediaUploading({
        uuid,
        isMediaUploading: true,
      })
    );
    uploadToursFileDirectUpload({
      token: fileServiceApiToken,
      organizationId,
      resourceId,
    })
      .unwrap()
      .then((data) => {
        const fileServiceUrl = data.file_service_url;
        const file = base64toFile(media as string);

        uploadFileToBucket({
          file,
          signedUrl: data.upload_url,
          onUploadProgress: (uploadProgress) => {
            onUploadProgress(uploadProgress, fileServiceUrl, type);
          },
        });
      })
      .catch(() => {
        notify.error('Something went wrong!');
      });
  };

  return { uploadTooltipMedia };
};

export default useTooltipMedia;
